import React, { Component } from "react";

class Contact extends Component {
  constructor() {
    super();
  }

  render() {
    return (
      <div className="slide-content">
        <div className="slide-panel contact-panel">
          <div className="contact-content clickable">
            <div className="contact-left">
              <div className="contact-line">Development by</div>
              <div className="axa-logo"></div>
              <div className="download-area">
                <div className="contact-line">Downloads</div>
                <ul className="downloads-list w-list-unstyled">
                  <li className="download-item">
                    <a
                      className="dl"
                      href="dl/TheFold_Brochure.pdf"
                      target="_blank"
                    >
                      Brochure <br />
                      (PDF, 5.8mb)
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="contact-right">
              <div className="contact-names">
                <div className="contact-name-col">
                  <div className="jll-logo"></div>

                  <div className="contact-name">
                    <span className="name">
                      Callum Fraser
                      <br />
                    </span>
                    <a href="mailto:callum.fraser@jll.com" className="email">
                      callum.fraser@jll.com
                    </a>
                    <br />
                    +44 7858 301 816
                  </div>
                  <div className="contact-name">
                    <span className="name">Joshua Doble</span>
                    <br />
                    <a href="mailto:joshua.doble@jll.com" className="email">
                      joshua.doble@jll.com
                    </a>{" "}
                    <br />
                    +44 7783 771 576
                  </div>
                </div>
                <div className="contact-name-col">
                  <div className="colliers-logo"></div>

                  <div className="contact-name">
                    <span className="name">Tom Slater</span>
                    <br />
                    <a href="mailto:tom.slater@knightfrank.com" className="email">
                      tom.slater@knightfrank.com
                    </a>
                    <br />
                    +44 7870 803 314
                  </div>
                  <div className="contact-name">
                    <span className="name">Jack Riley</span>
                    <br />
                    <a
                      href="mailto:jack.riley@knightfrank.com"
                      className="email"
                    >
                      jack.riley@knightfrank.com
                    </a>
                    <br />
                    +44 7867 002 484
                  </div>
                </div>
              </div>
              <div className="misrep">
                IMPORTANT NOTICE (1) Particulars: These particulars are not an offer or contract, nor part of one. You should not rely on statements by Knight Frank LLP, and its joint agent, JLL, in the particulars or by word of mouth or in writing (“information”) as being factually accurate about the property, its condition or its value. Knight Frank LLP has no authority to make any representations about the property, and accordingly any information given is entirely without responsibility on the part of the agents, seller(s) or lessor(s). (2) Photos etc: The photographs show only certain parts of the property as they appeared at the time they were taken. Areas, measurements and distances given are approximate only. (3) Regulations etc: Any reference to alterations to, or use of, any part of the property does not mean that any necessary planning, building regulations or other consent has been obtained. A buyer or lessee must find out by inspection or in other ways that these matters have been properly dealt with and that all information is correct. (4) VAT: The VAT position relating to the property may change without notice. Knight Frank LLP is a limited liability partnership registered in England with registered number OC305934. Knight Frank LLP registered office is 55 Baker Street, London, W1U 8AN, where you may look at a list of members’ names.<br />
                <h6>A website by <a href="https://www.mattersoho.co.uk">Matter</a>.</h6>
              </div>
               {/* <div>
                <p>A website by <a href="https://www.mattersoho.co.uk">Matter</a>.</p>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Contact;
